import { MenuListProps } from 'react-select';
import styled from 'styled-components';
import { OptionType } from './custom-dropdown-option';

const MenuRoot = styled.div`
  max-height: 80%;
  max-height: 80vh;
  overflow: auto;
`;

export function CustomMenuList(props: MenuListProps<OptionType, false>) {
  return (
    <MenuRoot>
      <div>{props.children}</div>
    </MenuRoot>
  );
}
